
import {
  computed,
  defineComponent,
  useContext,
  useFetch,
} from '@nuxtjs/composition-api';
import { useFetchBrand } from '@webplatform/nuxt-cms-js-sdk';

export default defineComponent({
  setup() {
    const { route, i18n } = useContext();
    const slug = computed(() => route.value.params.slug);
    const { brand, fetchBrand, pending } = useFetchBrand(slug.value, {
      lang: i18n.locale,
    });

    useFetch(async () => {
      await fetchBrand();
    });

    const breadcrumbs = computed(() => [
      {
        text: i18n.tc('vendor', 2),
        link: '/vendors',
      },
      {
        text: brand.value?.name,
      },
    ]);

    return {
      brand,
      breadcrumbs,
      pending,
    };
  },
  head: {},
});
